import { useReprocess } from "@/context/reprocess-context";
import { Loader2 } from "lucide-react";
import { createPortal } from "react-dom";

export const ReprocessFloatingCard = () => {
  const { isReprocessing } = useReprocess();

  if (!isReprocessing) return null;

  return createPortal(
    <div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 shadow-lg">
        <Loader2 className="h-4 w-4 animate-spin text-blue-600" />
        <div>
          <p className="text-sm font-medium text-blue-900">
            Reprocessando conciliação...
          </p>
          <p className="text-xs text-blue-700">
            As ações estão bloqueadas até a conclusão.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};
